<template>
    <div class="container">
        <transition mode="out-in" name="fade">
            <div v-if="currentCasePage">
                <page-component-container
                        :breadcrumbUrl="breadcrumbUrl"
                        :description="description"
                        :leftComponent="leftComponent"
                        :leftComponentOptions="leftComponentOptions"
                        :rightComponent="rightComponent"
                        :rightComponentOptions="rightComponentOptions"
                        :title="title"
                        :useTransitions="useTransitions"
                />
            </div>
            <div v-else>
                Current case page could not be found
            </div>
        </transition>
    </div>
</template>

<script>
    import GamePhase from '@/enum/GamePhase'
    import PageComponentContainer from '@/components/page-components/page-component-container';
    import {mapGetters} from 'vuex'
    import * as MutationTypes from '@/store/mutation-types'
    import {getTeacherUrl} from '@/utils/UrlUtil'

    export default {
        name: 'page-controller',
        components: {
            PageComponentContainer
        },
        props: {
            redirectToLobby: {
                type: Boolean,
                required: false,
                default: true
            },
            useTransitions: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        mounted() {
            if (this.redirectToLobby && (!this.currentCase || !this.$gameClient.isPhase([GamePhase.Pages]))) {
                console.log('Current case missing or $gameClient is not in the Pages phase - going back to lobby')

                // The game is not at the right point right now.. let's revert the user to the lobby screen
                this.$router.push(getTeacherUrl('lobby'))
            } else {
                this.$store.commit(MutationTypes.SET_NAVIGATION_GUARD_ENABLED, true);
            }
        },
        computed: {
            ...mapGetters({
                currentCase: 'getCurrentCase',
                currentPageIndex: 'getCurrentPageIndex'
            }),

            breadcrumbUrl() {
                return getTeacherUrl('lobby');
            },

            currentCasePage() {
                if (this.currentCase && this.currentCase.pages && this.currentCase.pages.length > this.currentPageIndex) {
                    return this.currentCase.pages[this.currentPageIndex];
                } else {
                    return null;
                }
            },

            title() {
                if (!this.currentCasePage) {
                    return null;
                }

                return this.currentCasePage.title || ''
            },

            description() {
                if (!this.currentCasePage) {
                    return null;
                }

                return this.currentCasePage.description || ''
            },

            left() {
                if (!this.currentCasePage) {
                    return null;
                }

                return this.currentCasePage.components.hasOwnProperty('left') ? this.currentCasePage.components.left : null;
            },
            leftComponent() {
                return this.left ? this.left.component : null;
            },
            leftComponentOptions() {
                if (!this.left) {
                    return null;
                }

                if (this.left.options instanceof Array) {
                    return null;
                }

                return this.left.options;
            },

            right() {
                if (!this.currentCasePage) {
                    return null;
                }

                return this.currentCasePage.components.hasOwnProperty('right') ? this.currentCasePage.components.right : null;
            },
            rightComponent() {
                return this.right ? this.right.component : null;
            },
            rightComponentOptions() {
                if (!this.right) {
                    return null;
                }

                if (this.right.options instanceof Array) {
                    return null;
                }

                return this.right.options;
            }
        }
    }
</script>

<style lang="less" scoped>
    .continue-button-container {
        text-align: center;
    }
</style>